"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get generateSwagger () {
        return generateSwagger;
    },
    get prepareSwaggerGenerationData () {
        return prepareSwaggerGenerationData;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
const _dbHelpers = require("~/helpers/dbHelpers");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function prepareSwaggerGenerationData({ context, models, sourcesMap, ncMeta = _Noco.default.ncMeta }) {
    // Pre-construct table names for all models to avoid repeated construction and handle duplicates
    const tableNamesMap = new Map();
    const usedTableNames = new Set();
    for (const model of models){
        const source = sourcesMap.get(model.source_id);
        const sourcePrefix = (0, _dbHelpers.swaggerGetSourcePrefix)(source);
        const tableName = `${sourcePrefix}${model.title}`;
        // Handle duplicate table names by adding a number suffix
        let finalTableName = tableName;
        let counter = 1;
        while(usedTableNames.has(finalTableName)){
            finalTableName = `${tableName}_${counter}`;
            counter++;
        }
        usedTableNames.add(finalTableName);
        tableNamesMap.set(model.id, finalTableName);
    }
    // Prepare views data for all models
    const swaggerViews = new Map();
    for (const model of models){
        const views = [];
        for (const view of await model.getViews(context, false, ncMeta) || []){
            if (view.type !== _nocodbsdk.ViewTypes.GRID) continue;
            views.push({
                view,
                columns: await view.getColumns(context, ncMeta)
            });
        }
        swaggerViews.set(model.id, views);
    }
    return {
        sourcesMap,
        tableNamesMap,
        swaggerViews
    };
}
async function generateSwagger(generationContext, swaggerBase, getSwaggerColumnMetas, getPaths, getSchemas, transformViews) {
    const { context, base, models, sourcesMap, ncMeta = _Noco.default.ncMeta } = generationContext;
    // base swagger object
    const swaggerObj = _extends({}, swaggerBase, {
        paths: {},
        components: _extends({}, swaggerBase.components, {
            schemas: _extends({}, swaggerBase.components.schemas)
        })
    });
    // Prepare common data structures
    const { tableNamesMap, swaggerViews } = await prepareSwaggerGenerationData(generationContext);
    // iterate and populate swagger schema and path for models and views
    for (const model of models){
        let paths = {};
        const columns = await getSwaggerColumnMetas(context, {
            columns: await model.getColumns(context, ncMeta),
            model,
            sourcesMap,
            base
        }, ncMeta);
        const modelViews = swaggerViews.get(model.id) || [];
        const views = transformViews ? transformViews(modelViews) : modelViews;
        // skip mm tables
        if (!model.mm) {
            paths = await getPaths(context, {
                base,
                model,
                columns,
                views,
                sourcesMap,
                tableName: tableNamesMap.get(model.id)
            }, ncMeta);
        }
        const schemas = await getSchemas(context, {
            base,
            model,
            columns,
            views,
            sourcesMap,
            tableName: tableNamesMap.get(model.id)
        }, ncMeta);
        Object.assign(swaggerObj.paths, paths);
        Object.assign(swaggerObj.components.schemas, schemas);
    }
    return swaggerObj;
}
